




























import { computed, defineComponent, toRefs } from '@vue/composition-api';
import CreativeProductTileSwipeLeftTipPng from '@tt4b/ttam-assets/src/images/creative/creative-product-tile-swipe-left-tip.png';
import QuestionTooltipWithImage from '@/components/common/question-tooltip-with-image/index.vue';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import CatalogCarouselSwipeLeftTipPng from '@tt4b/ttam-assets/src/images/creative/catalog-carousel-swipe-left-tip.png';

const name = 'ttam-creative-general-deeplink-switch';
export default defineComponent({
  name,
  components: {
    QuestionTooltipWithImage,
    QuestionTooltip,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onlySupportCustomLink: {
      type: Boolean,
      default: false,
    },
    isSingleVideo: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const _isOpenUrl = computed({
      get: () => value.value,
      set: v => {
        emit('input', v);
        emit('change', v);
      },
    });
    return {
      name,
      _isOpenUrl,
      CreativeProductTileSwipeLeftTipPng,
      CatalogCarouselSwipeLeftTipPng,
    };
  },
});
